export default "__VITE_ASSET__CCIK4$sy__"